<div class="hvac-landing-page-content">
    <section class="hvac-landing-page-section">
        <h2 class="hvac-landing-page-heading">{{ 'HOMEPAGE.BROWSE_PRODUCTS_TITLE' | translate }}</h2>
        <p class="hvac-landing-page-paragraph">{{ 'HOMEPAGE.BROWSE_PRODUCTS_PARAGRAPH' | translate }}</p>
        <router-outlet #o="outlet" class="home"></router-outlet>
    </section>
</div>
